import {z} from "zod/v4-mini"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            angleInDegrees: z.number(), // angle in degrees to rotate by
            angleFactor: z._default(z.number(), 1), // factor by which a full rotation is accomplished; 1 for vectors which repeat in 360°; 2 for vectors which repeat in 180°; negative values reverse cw/ccw; default: 1
        }),
    },
}
